<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 14:43:44
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-14 11:27:26
-->
<template>
  <div class="comment-list-base">
    <div class="comment_info">
      <div class="comment_info-title">{{ selfTopic.title }}</div>
      <div class="comment_info-info">
        <span v-if="selfTopic.category">#{{ selfTopic.category }}/</span>
        <span v-if="selfTopic.city">{{ selfTopic.city }}/</span>
        <span v-if="selfTopic.date">{{ selfTopic.date }}</span>
      </div>
      <div class="comment_info-p">
        {{ selfTopic.intro }}
      </div>
    </div>
    <div class="comment-ipt-bl">
      <div class="comments-no">评论({{ commentPaging.total }})</div>
      <el-input class="comment-ipt" type="textarea" autosize placeholder="请输入评论内容" v-model="userComment" @focus="inputFocus"> </el-input>
      <div class="actions-wrap">
        <div class="submit_btn" @click="addComment">发表评论</div>
      </div>
    </div>
    <div class="comments" v-if="comments.length">
      <div class="comment-item" v-for="(item, index) in comments" :key="item.id">
        <div class="user_avatar">
          <img class="user_avatar-img" :src="item.user && item.user.avater" alt="" />
        </div>
        <div class="comment-info">
          <div class="user_name-wrap">
            <div class="user_name">{{ item.user && item.user.nickname }}</div>
            <div class="praise_no" @click.stop="pageCommentThumb(item.id, index)">
              <i class="iconfont iconpraise" :class="{ activated: item.is_thumb }"></i>
              {{ item.like_count }}
            </div>
          </div>
          <div class="comment_content">
            {{ item.content }}
          </div>
          <div class="comment_bottom-wrap">
            <div class="comment_date">{{ item.date }}</div>
            <div class="reply_btn" @click="showReplyIpt(index, true)">回复</div>
          </div>
          <div class="reply_comments-wrap" v-if="item.reply_comments && item.reply_comments.length">
            <div class="reply_comments">
              <div class="reply_comment" v-for="replyComment in item.reply_comments" :key="replyComment.id">
                <span class="nickname">{{ replyComment.nickname }}：</span>{{ replyComment.content }}
              </div>
            </div>
            <div class="reply_comments-count" @click.stop="showReplyCommentsDialog(item.id)">{{ item.reply_comment_count }}条回复</div>
          </div>
          <transition name="el-zoom-in-top">
            <div class="reply_ipt-bl" v-show="item.showReply">
              <el-input
                class="reply_ipt-wrap"
                type="textarea"
                autosize
                :placeholder="`回复：${selectComment.user && selectComment.user.nickname}`"
                v-model="userReply"
                @focus="inputFocus"
              >
              </el-input>
              <div class="reply_ipt-actions">
                <div class="cancel_btn" @click="showReplyIpt(index, false)">取消</div>
                <div class="reply_btn" @click="onClickReply">回复</div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="more_btn" v-show="!isLoadedAll" @click="loadMoreComments">
        查看更多
      </div>
    </div>
    <div class="empty-bl" v-else>
      暂无评论
    </div>
    <el-dialog
      class="reply_comments-dialog"
      :visible.sync="replyCommentsDialog"
      width="600px"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="true"
      ref="replyCommentsDialog"
    >
      <div class="dialog-container">
        <div class="comment-item">
          <div class="user_avatar">
            <img class="user_avatar-img" :src="replyCommentData.user.avater" alt="" />
          </div>
          <div class="comment-info">
            <div class="user_name-wrap">
              <div class="user_name">{{ replyCommentData.user.nickname }}</div>
              <div class="praise_no" @click.stop="replyDialogUperThumb()">
                <i class="iconfont iconpraise" :class="{ activated: replyCommentData.is_thumb }"></i>
                {{ replyCommentData.like_count }}
              </div>
            </div>
            <div class="comment_content">
              {{ replyCommentData.content }}
            </div>
            <div class="comment_bottom-wrap">
              <div class="comment_date">{{ replyCommentData.date }}</div>
              <div class="reply_btn" @click="onClickDialogReply(replyCommentData)">回复</div>
            </div>
          </div>
        </div>
        <div class="title">全部回复</div>
        <div class="reply_comments" v-if="replyCommentCurList.length">
          <div class="comment-item" v-for="(comment, index) in replyCommentCurList" :key="comment.id">
            <div class="user_avatar">
              <img class="user_avatar-img" :src="comment.user.avater" alt="" />
            </div>
            <div class="comment-info">
              <div class="user_name-wrap">
                <div class="user_name">{{ comment.user.nickname }}</div>
                <div class="praise_no" @click.stop="replyDialogCommentThumb(comment.id, index)">
                  <i class="iconfont iconpraise" :class="{ activated: comment.is_thumb }"></i>
                  {{ comment.like_count }}
                </div>
              </div>
              <div class="comment_content">
                {{ comment.content }}
              </div>
              <div class="comment_bottom-wrap">
                <div class="comment_date">{{ comment.created }}</div>
                <div class="reply_btn" @click="onClickDialogReply(comment)">回复</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="reply_ipt-wrap">
        <input class="reply_dialog_ipt" :placeholder="replyDialogPlaceholder" v-model="dialogReply" @focus="inputFocus" @input="onInputDialogReply" />
        <div class="send_btn" @click.stop="sendDialogReply">发送</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Input, Dialog } from 'element-ui';
import requestApi from '@/service';
export default {
  props: {
    topic: {
      type: Object,
      default: () => {},
    },
    datas: {
      type: Array,
      default: () => [],
    },
    type: String,
    id: [String, Number],
  },
  components: {
    [Input.name]: Input,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      comments: [],
      selfTopic: {},
      userComment: '', // 用户评论
      userReply: '', // 用户回复
      queryId: '', // 查询id
      queryType: this.type, // 查询type
      commentPaging: {
        pageNum: 1,
        pageSize: 4,
        total: 0,
      },
      replyCommentsDialog: false, //查看全部回复弹出框
      replyCommentData: {
        user: {},
      }, // 当前被查看评论的评论
      replyCommentCurList: [], // 当前打开评论列表
      dialogReply: '', // 回复弹出框的回复信息
      selectDialogComment: {}, // 选中的回复弹框内的某条回复
      selectComment: {}, // 当前选中的列表中的回复
    };
  },
  watch: {
    topic(data) {
      this.selfTopic = data;
    },
    datas(arr) {
      this.comments = arr;
    },
    id(id) {
      if (this.queryId !== id) {
        this.queryId = id;
        this.refreshData();
      }
    },
    type(type) {
      this.queryType = type;
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    isLoadedAll() {
      return this.commentPaging.total && this.commentPaging.total / this.commentPaging.pageSize <= this.commentPaging.pageNum;
    },
    replyDialogPlaceholder() {
      return this.selectDialogComment.name ? `@${this.selectDialogComment.name}` : '在这里回复评论';
    },
  },
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
      this.selfTopic = this.topic;
      this.queryId = this.id;
      this.queryType = this.type;
      if (this.queryId) {
        this.refreshData();
      }
    },
    showReplyIpt(index, val) {
      if (this.checkLogin()) {
        this.$set(this.comments[index], 'showReply', val);
        this.selectComment = this.comments[index];
        this.userReply = '';
      }
    },
    inputFocus() {
      this.$emit('inputFocus', true);
    },
    refreshData() {
      // 截流处理
      this.commentPaging.pageNum = 1;
      this.getComments();
    },
    getComments() {
      if (this.queryType && this.queryId) {
        // 由于这里的id并不统一 所以莫法 只能再搞一遍
        let key = `${this.queryType}_id`;
        if (this.type === 'zhiya' || this.type === 'wanxiang') {
          key = `${this.type}video_id`;
        }
        const params = { [key]: this.queryId, page: this.commentPaging.pageNum, page_size: this.commentPaging.pageSize };
        requestApi(`/api/h5/comments/`, params).then(({ items, total, page }) => {
          if (page === 1) {
            this.comments = items;
            this.commentPaging.total = total;
          } else {
            this.comments.push(...items);
          }
        });
      }
    },
    loadMoreComments() {
      if (!this.isLoadedAll) {
        this.commentPaging.pageNum += 1;
        this.getComments();
      }
    },
    /**
     * @description: 显示评论的回复
     */
    showReplyCommentsDialog(id) {
      this.replyDialogCommentId = id;
      this.replyCommentPaging = {
        pageNum: 1,
        pageSize: 999,
      };
      this.getReplyCommentsDialogData().then(() => {
        this.replyCommentsDialog = true;
        this.$nextTick(() => {
          this.$refs.replyCommentsDialog.$el.getElementsByClassName('dialog-container')[0].scrollTo(0, 0);
        });
      });
    },
    getReplyCommentsDialogData() {
      return requestApi('/api/h5/comment/all/', {
        comment_id: this.replyDialogCommentId,
        page: this.replyCommentPaging.pageNum,
        page_size: this.replyCommentPaging.pageSize,
      }).then(({ base_comment, reply_info }) => {
        this.replyCommentData = base_comment;
        this.replyCommentCurList = reply_info.reply_comments;
        this.selectDialogComment = { id: base_comment.id }; // 默认回复主楼层
        this.dialogReply = '';
      });
    },
    /**
     * @description: 弹出框回复
     */
    onInputDialogReply(e) {
      this.dialogReply = e.target.value;
    },
    /**
     * @description: 评论弹出框回复发送
     */
    sendDialogReply() {
      this.submitReply(this.selectDialogComment.id, this.dialogReply).then(() => {
        this.getReplyCommentsDialogData();
      });
    },
    submitReply(comment_id, content) {
      return requestApi(
        '/api/v1/comment/reply/',
        {
          comment_id,
          content,
        },
        'POST'
      );
    },
    /**
     * @description: 发表评论
     */
    addComment() {
      if (this.checkLogin() && this.userComment) {
        let key = `${this.type}_id`;
        if (this.type === 'zhiya' || this.type === 'wanxiang') {
          key = `${this.type}_video_id`;
        }
        const params = {
          content: this.userComment,
          [key]: this.id,
        };
        requestApi(`/api/v1/${this.type}/comment/add/`, params, 'PUT').then(() => {
          this.userComment = '';
          this.$message.success('评论成功');
          this.refreshData();
        });
      }
    },
    /**
     * @description: 页面评论列表回复按钮
     */
    onClickReply() {
      if (this.checkLogin()) {
        this.submitReply(this.selectComment.id, this.userReply).then(() => {
          this.refreshData();
        });
      }
    },
    onClickDialogReply(comment) {
      this.selectDialogComment = { name: comment.user.nickname, id: comment.id };
    },
    /**
     * @description: 回复弹出框顶部主评论点赞
     */
    replyDialogUperThumb(comment = this.replyCommentData) {
      this.commentThumb(comment.id).then(res => {
        if (res) {
          this.replyCommentData.is_thumb = !this.replyCommentData.is_thumb;
          this.replyCommentData.like_count = this.replyCommentData.is_thumb
            ? this.replyCommentData.like_count + 1
            : this.replyCommentData.like_count - 1;
        }
      });
    },
    replyDialogCommentThumb(id, index) {
      this.commentThumb(id).then(res => {
        if (res && this.replyCommentCurList[index]) {
          const comment = this.replyCommentCurList[index];
          const likeCount = comment.is_thumb ? comment.like_count - 1 : comment.like_count + 1;
          const obj = { ...comment, is_thumb: !comment.is_thumb, like_count: likeCount };
          this.$set(this.replyCommentCurList, index, obj);
        }
      });
    },
    pageCommentThumb(id, index) {
      this.commentThumb(id).then(res => {
        if (res) {
          const comment = this.comments[index];
          const likeCount = comment.is_thumb ? comment.like_count - 1 : comment.like_count + 1;
          const obj = { ...comment, is_thumb: !comment.is_thumb, like_count: likeCount };
          this.$set(this.comments, index, obj);
        }
      });
    },
    commentThumb(id) {
      return new Promise(resolve => {
        if (this.checkLogin()) {
          requestApi(
            '/api/v1/comment/thumb/',
            {
              comment_id: id,
            },
            'post'
          ).then(() => {
            resolve(true);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-list-base {
  .comment_info {
    padding: 35px 0 40px;
    &-title {
      font-family: HYXinRenWenSongW;
      font-size: 27px;
      color: $C6;
      line-height: 27px;
      margin-bottom: 11px;
    }
    &-info {
      font-size: 14px;
      color: $C5;
      letter-spacing: 1.7px;
      text-align: left;
      line-height: 14px;
      margin-bottom: 28px;
    }
    &-p {
      font-size: 16px;
      color: $C6;
      line-height: 26px;
    }
  }
}
.comment-ipt-bl {
  .comments-no {
    color: $C6;
    text-align: left;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 15px;
  }
  .comment-ipt {
    width: 100%;
    font-size: 14px;
    line-height: 14px;
    ::v-deep.el-textarea__inner {
      padding: 15px;
      border-radius: 0;
      border: 1px solid $C11;
      min-height: 116px !important;
      resize: none;
    }
  }
  .actions-wrap {
    margin-top: 15px;
    text-align: right;
  }
  .submit_btn {
    display: inline-block;
    padding: 12px 32px;
    font-size: 14px;
    color: $C11;
    background-color: $C2;
    text-align: center;
    cursor: pointer;
    opacity: 0.9;
    &:hover {
      opacity: 1;
    }
  }
}
.comments {
  .comment-item {
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: #e8e8e8;
      bottom: 0;
      left: 0;
    }
    .reply_comments-wrap {
      margin-top: 25px;
      background: $C10;
      font-size: 14px;
    }
    .reply_ipt-bl {
      min-height: 260px;
      .reply_ipt-wrap {
        width: 100%;
        margin-top: 17px;
        background: $C1;
        font-size: 14px;
        line-height: 14px;
        ::v-deep.el-textarea__inner {
          padding: 15px;
          border-radius: 0;
          border: 1px solid $C11;
          min-height: 116px !important;
          resize: none;
        }
      }
      .reply_ipt-actions {
        text-align: right;
        margin-top: 15px;
        .cancel_btn,
        .reply_btn {
          display: inline-block;
          cursor: pointer;
          width: 89px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #ebebeb;
          text-align: center;
        }
        .cancel_btn {
          background: #b5b5b5;
          margin-right: 10px;
        }
        .reply_btn {
          background: $C2;
        }
      }
    }
  }
  .more_btn {
    margin: 33px auto;
    text-align: center;
    color: $C2;
    font-size: 14px;
    cursor: pointer;
  }
}

.reply_comments {
  padding: 15px 0;
  .reply_comment {
    padding: 0 20px;
    text-align: left;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
    .nickname {
      color: #4a4a4a;
    }
  }
  &-count {
    text-align: center;
    padding: 10px;
    color: #4a4a4a;
    cursor: pointer;
    border-top: 1px solid rgba(189, 189, 189, 0.3);
  }
}
.empty-bl {
  text-align: center;
  padding: 80px 0 30px;
  color: $C5;
  font-size: 14px;
}
.comments,
.reply_comments-dialog {
  .comment-item {
    display: flex;
    align-items: flex-start;
    padding: 30px 0;
    position: relative;
    .comment-info {
      flex: 1;
      .user_name-wrap {
        height: 40px;
        font-size: 14px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .user_name {
          color: $C4;
        }
        .praise_no {
          cursor: pointer;
          letter-spacing: 1.7px;
          .iconfont {
            font-size: 18px;
            color: $C5;
            &.activated {
              color: $C2;
            }
          }
        }
      }
    }
    .user_avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 20px;
      margin-right: 20px;
      border-radius: 50%;
      overflow: hidden;
    }
    .comment_content {
      font-size: 16px;
      color: $C3;
      line-height: 20px;
      margin-bottom: 15px;
    }
    .comment_bottom-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: $C12;
      .reply_btn {
        cursor: pointer;
      }
    }
  }
}
.reply_comments-dialog {
  overflow: hidden;
  ::v-deep.el-dialog__header {
    padding: 0;
  }
  ::v-deep.el-dialog {
    height: 90vh;
    max-height: 760px;
    overflow: hidden;
    margin-top: 5vh !important;
  }
  ::v-deep.el-dialog__headerbtn {
    top: 15px;
  }
  ::v-deep.el-dialog__body {
    height: 100%;
    overflow-y: auto;
    padding: 0;
  }
  .title {
    font-size: 18px;
    padding-left: 30px;
    margin-top: 30px;
    color: $C3;
  }
  .dialog-container {
    height: calc(100% - 52px);
    overflow-y: auto;
  }
  .comment-item {
    padding: 30px 20px 30px 30px;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.6);
    .user_avatar {
      width: 30px;
      height: 30px;
    }
    .comment-info {
      .user_name-wrap {
        height: auto;
        margin-bottom: 0;
      }
      .comment_content {
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }
  .reply_comments {
    border-bottom: 0;
    overflow: hidden;
    padding-bottom: 30px;
    background: $C1;
    .comment-item {
      position: relative;
      border-bottom: none;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 80px;
        height: 0;
        width: 100%;
        border-bottom: 1px dashed rgba(0, 0, 0, 0.6);
      }
    }
  }
  .reply_ipt-wrap {
    display: flex;
    align-items: center;
    height: 50px;
    background: #f7f7f7;
    .reply_dialog_ipt {
      flex: 1;
      border: none;
      outline: none;
      height: 100%;
      font-size: 16px;
      color: $C3;
      padding-left: 30px;
      background: transparent;
    }
    .send_btn {
      font-size: 16px;
      color: $C3;
      width: 120px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
    }
  }
}
</style>
